import React from 'react';
import ServicePage from '../components/services/ServicePage';
import tablecloths from '../data/services/tablecloths';

const Tablecloths: React.FC = () => <ServicePage data={tablecloths} />;

export default Tablecloths;
